/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpSummaryServiceApi', ($http, ApiErrorService) => {
    return {
        lastPage: lastPage,
        firstPage: firstPage,
        prevPage: prevPage,
        nextPage: nextPage,
        getTraceChildren: getTraceChildren,
        getDvTraceChildren: getDvTraceChildren,
        getTraceXmlAttributes: getTraceXmlAttributes,
        getTraceXmlContent: getTraceXmlContent,
        testersWithTraceCount: testersWithTraceCount,
        getTestIdNameResponse: getTestIdNameResponse,
        getTraceTestAndAttributes: getTraceTestAndAttributes,
        getRawMessage: getRawMessage
    };
    function lastPage(req, addChildren) {
        return $http.post(`api/UtpSummary/LastPage?addChildren=${addChildren}`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function firstPage(req, addChildren, shouldFillFirstPage) {
        return $http.post(`api/UtpSummary/FirstPage?addChildren=${addChildren}&shouldFillFirstPage=${shouldFillFirstPage}`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function prevPage(req, addChildren) {
        return $http.post(`api/UtpSummary/PrevPage?addChildren=${addChildren}`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function nextPage(req, addChildren) {
        return $http.post(`api/UtpSummary/NextPage?addChildren=${addChildren}`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTraceChildren(traceId) {
        return $http.get(`api/UtpSummary/GetTraceChildren?traceId=${traceId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getDvTraceChildren(traceId, isDvSummary) {
        return $http.get(`api/UtpSummary/GetDvTraceChildren?traceId=${traceId}&isDvSummary=${isDvSummary}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTraceXmlAttributes(traceId) {
        return $http.get(`api/UtpSummary/GetTraceXmlAttributes?traceId=${traceId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTraceXmlContent(traceId, formatXml) {
        return $http.get(`api/UtpSummary/GetTraceXmlContent?traceId=${traceId}&formatXml=${formatXml}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testersWithTraceCount() {
        return $http.get(`api/UtpSummary/TestersWithTraceCount`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestIdNameResponse(testId) {
        return $http.get(`api/UtpSummary/GetTestIdNameResponse?testId=${testId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTraceTestAndAttributes(testId, traceId) {
        return $http.get(`api/UtpSummary/GetTraceTestAndAttributes?testId=${testId}&traceId=${traceId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getRawMessage(id) {
        return $http.get(`api/UtpSummary/GetRawMessage?id=${id}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
